export default "__VITE_ASSET__f56e0598__"